import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT;

class StaticTextService {
    async find(languageCode: string, includeHidden: boolean = false) {
        return await Api().get(`${API_URL}/statictext/find?languageCode=${encodeURIComponent(languageCode)}&includeHidden=${includeHidden}`, { headers: authHeader() as any });
    }

    async getTranslations(label: string) {
        return await Api().get(`${API_URL}/statictext/translations/${encodeURIComponent(label)}`, { headers: authHeader() as any });
    }

    async updateText(id: number, text: string, isHtmlEdited: boolean = false) {
        return await Api().put(`${API_URL}/statictext/${id}/text`, { text, isHtmlEdited }, { headers: authHeader() as any });
    }

    async updateAdmin(label: string, description: string, isHideOnAqua: boolean) {
        return await Api().put(`${API_URL}/statictext/admin/${encodeURIComponent(label)}`, { description, isHideOnAqua }, { headers: authHeader() as any });
    }

    async createTranslation(label: string, languageCode: string, text: string, isHtmlEdited: boolean = false) {
        return await Api().post(`${API_URL}/statictext`, { label, languageCode, text, isHtmlEdited }, { headers: authHeader() as any });
    }
}

export default new StaticTextService();
